import React from "react";
import { Link } from "react-router-dom";
import { Bell, ShoppingBag, CreditCard, CheckCheck } from "lucide-react";
import { useNotifications } from "@/context/NotificationsContext";

export default function Notifications() {
  const { notifications, markAllRead, clearAll, unread } = useNotifications();

  return (
    <div className="container-app py-8 sm:py-12 max-w-2xl">
      <div className="flex items-center justify-between">
        <h1 className="font-display text-4xl" style={{ color: "var(--ink)" }}>Notifications</h1>
        {notifications.length > 0 && (
          <div className="flex gap-2">
            {unread > 0 && (
              <button onClick={markAllRead} data-testid="mark-all-read" className="text-sm font-semibold inline-flex items-center gap-1.5" style={{ color: "var(--brand)" }}>
                <CheckCheck size={16} /> Mark all read
              </button>
            )}
            <button onClick={clearAll} className="text-sm underline" style={{ color: "var(--muted)" }}>Clear</button>
          </div>
        )}
      </div>

      {notifications.length === 0 ? (
        <div className="mt-10 text-center py-16 rounded-2xl" style={{ background: "var(--surface)", border: "1px dashed var(--border)" }}>
          <Bell className="mx-auto mb-3" style={{ color: "var(--muted)" }} size={28} />
          <p className="font-display text-xl" style={{ color: "var(--ink)" }}>You're all caught up</p>
          <p className="text-sm mt-1" style={{ color: "var(--muted)" }}>Order updates and reminders will appear here.</p>
        </div>
      ) : (
        <div className="mt-6 space-y-2">
          {notifications.map((n) => {
            const Icon = n.type === "balance" ? CreditCard : ShoppingBag;
            const body = (
              <div
                className="flex gap-3 rounded-2xl p-4"
                style={{ background: n.read ? "var(--surface)" : "var(--accent-soft)", border: "1px solid var(--border)" }}
              >
                <div className="h-9 w-9 rounded-full flex items-center justify-center shrink-0" style={{ background: "var(--brand)", color: "var(--brand-fg)" }}>
                  <Icon size={16} />
                </div>
                <div className="flex-1">
                  <div className="font-semibold" style={{ color: "var(--ink)" }}>{n.title}</div>
                  <div className="text-sm" style={{ color: "var(--muted)" }}>{n.body}</div>
                  <div className="text-xs mt-1" style={{ color: "var(--muted)" }}>{new Date(n.at).toLocaleString()}</div>
                </div>
              </div>
            );
            return n.order_id ? (
              <Link key={n.id} to={`/order/${n.order_id}`} data-testid={`notif-${n.id}`}>{body}</Link>
            ) : (
              <div key={n.id} data-testid={`notif-${n.id}`}>{body}</div>
            );
          })}
        </div>
      )}
    </div>
  );
}
